<section>
  <h1 class="visually-hidden">Manage Duplicates</h1>
  <h2 class="h1">Compare and Merge Duplicates</h2>
  <a [routerLink]="['/manageduplicates']" class="d-block">&lt;&lt; Return to Manage Duplicates List</a>
  <p>Select the values for each field that should be merged into one person. Then tap Confirm Merge to complete the merge.</p>
  <p-messages key="personMergeMsg" [closable]="true" [enableService]="true"></p-messages>
  <fieldset class="mb-3">
    <legend class="visually-hidden">Select fields to show</legend>
    <div class="form-check form-check-inline">
      <input id="showDifferentFields" class="form-check-input" type="radio" name="mergeValuesDisplaying" value="different" [(ngModel)]="displayMerge" (click)="changeSort('different')" />
      <label for="showDifferentFields" class="form-check-label">Show fields with different values</label>
    </div>
    <div class="form-check form-check-inline">
      <input id="showAllFields" class="form-check-input" type="radio" name="mergeValuesDisplaying" value="all" [(ngModel)]="displayMerge" (click)="changeSort('all')" />
      <label for="showAllFields" class="form-check-label">Show all fields</label>
    </div>
  </fieldset>
  <form class="overflow-x-auto table-responsive">
    <table class="temp-bs table table-sm table-striped table-bordered" aria-describedby="DataTable">
      <thead>
        <tr>
          <th scope="col" width="{{ width1 }}"><span class="visually-hidden">Field</span></th>
          <th scope="col" width="{{ width2 }}">
            {{ people[0]?.FirstName }} {{ people[0]?.LastName }}
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="selectAll1" [ngModelOptions]="{standalone: true}" id="select1" (click)="checkAll($event.target['id'], selectAll1)" [checked]="selectAll1" />
              <label class="form-check-label" for="select1">Select All</label>
            </div>
          </th>
          <th scope="col" width="{{ width2 }}">
            {{ people[1]?.FirstName }} {{ people[1]?.LastName }}
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="selectAll2" [ngModelOptions]="{standalone: true}" id="select2" (click)="checkAll($event.target['id'], selectAll2)" [checked]="selectAll2" />
              <label class="form-check-label" for="select2">Select All</label>
            </div>
          </th>
          <th scope="col" width="{{ width3 }}" *ngIf="people.length == 3">
            {{ people[2]?.FirstName }} {{ people[2]?.LastName }}
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="selectAll3" [ngModelOptions]="{standalone: true}" id="select3" (click)="checkAll($event.target['id'], selectAll3)" [checked]="selectAll3" />
              <label class="form-check-label" for="select3">Select All</label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr [hidden]="hideFirstName" role="radiogroup" aria-labelledby="GroupLabelFirstName">
          <th scope="row" class="text-right" id="GroupLabelFirstName">First Name:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="a.checked ? 'selected' : ''">
            <div class="form-check">
              <input #a id="fName{{i}}" class="form-check-input" type="radio" name="FirstName" value="{{ person?.FirstName }}" (change)="updateFirstName(person.FirstName)" [checked]="personSelected == i" />
              <label for="fName{{i}}" class="form-check-label">{{ person?.FirstName }}<span *ngIf="!person?.FirstName" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideMiddleName" role="radiogroup" aria-labelledby="GroupLabelMiddleName">
          <th scope="row" class="text-right" id="GroupLabelMiddleName">Middle Name:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="b.checked ? 'selected' : ''">
            <div class="form-check">
              <input #b id="mName{{i}}" class="form-check-input" type="radio" name="MiddleName" value="{{ person?.MiddleName }}" (change)="updateMiddleName(person.MiddleName)" [checked]="personSelected == i" />
              <label for="mName{{i}}" class="form-check-label">{{ person?.MiddleName }}<span *ngIf="!person?.MiddleName" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideLastName" role="radiogroup" aria-labelledby="GroupLabelLastName">
          <th scope="row" class="text-right" id="GroupLabelLastName">Last Name:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="c.checked ? 'selected' : ''">
            <div class="form-check">
              <input #c id="lName{{i}}" class="form-check-input" type="radio" name="LastName" value="{{ person?.LastName }}" (change)="updateLastName(person.LastName)" [checked]="personSelected == i" />
              <label for="lName{{i}}" class="form-check-label">{{ person?.LastName }}<span *ngIf="!person?.LastName" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideSuffix" role="radiogroup" aria-labelledby="GroupLabelSuffix">
          <th scope="row" class="text-right" id="GroupLabelSuffix">Suffix:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="d.checked ? 'selected' : ''">
            <div class="form-check">
              <input #d id="suffix{{i}}" class="form-check-input" type="radio" name="Suffix" value="{{ person?.Suffix }}" (change)="updateSuffix(person.Suffix)" [checked]="personSelected == i" />
              <label for="suffix{{i}}" class="form-check-label">{{ person?.Suffix }}<span *ngIf="!person?.Suffix" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideAlias" role="radiogroup" aria-labelledby="GroupLabelAlias">
          <th scope="row" class="text-right" id="GroupLabelAlias">Alias:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="e.checked ? 'selected' : ''">
            <div class="form-check">
              <input #e id="alias{{i}}" class="form-check-input" type="radio" name="Alias" value="{{ person?.Alias }}" (change)="updateAlias(person.Alias)" [checked]="personSelected == i" />
              <label for="alias{{i}}" class="form-check-label">{{ person?.Alias }}<span *ngIf="!person?.Alias" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideNickName" role="radiogroup" aria-labelledby="GroupLabelNickName">
          <th scope="row" class="text-right" id="GroupLabelNickName">Nickname:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="f.checked ? 'selected' : ''">
            <div class="form-check">
              <input #f id="nickName{{i}}" class="form-check-input" type="radio" name="NickName" value="{{ person?.NickName }}" (change)="updateNickName(person.NickName)" [checked]="personSelected == i" />
              <label for="nickName{{i}}" class="form-check-label">{{ person?.NickName }}<span *ngIf="!person?.NickName" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideGenderID" role="radiogroup" aria-labelledby="GroupLabelGender">
          <th scope="row" class="text-right" id="GroupLabelGender">Sex:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="g.checked ? 'selected' : ''">
            <div class="form-check">
              <input #g id="gender{{i}}" class="form-check-input" type="radio" name="GenderID" value="{{ person?.ENESS_REF_Genders?.GenderID }}" (change)="updateGenderID(person?.ENESS_REF_Genders)" [checked]="personSelected == i" />
              <label for="gender{{i}}" class="form-check-label">{{ person?.ENESS_REF_Genders?.GenderName }}<span *ngIf="!person?.ENESS_REF_Genders?.GenderID" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideRaceID" role="radiogroup" aria-labelledby="GroupLabelRaceID">
          <th scope="row" class="text-right" id="GroupLabelRaceID">Race:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="h.checked ? 'selected' : ''">
            <div class="form-check">
              <input #h id="race{{i}}" class="form-check-input" type="radio" name="RaceID" value="{{ person?.ENESS_REF_Races?.RaceID }}" (change)="updateRaceID(person?.ENESS_REF_Races)" [checked]="personSelected == i" />
              <label for="race{{i}}" class="form-check-label">{{ person?.ENESS_REF_Races?.RaceName }}<span *ngIf="!person?.ENESS_REF_Races?.RaceID" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideGangName" role="radiogroup" aria-labelledby="GroupLabelGangName">
          <th scope="row" class="text-right" id="GroupLabelGangName">Gang affiliation:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="j.checked ? 'selected' : ''">
            <div class="form-check">
              <input #j id="gang{{i}}" class="form-check-input" type="radio" name="GangName" value="{{ person?.GangName }}" (change)="updateGangName(person.GangName)" [checked]="personSelected == i" />
              <label for="gang{{i}}" class="form-check-label">{{ person?.GangName }}<span *ngIf="!person?.GangName" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideDateOfBirth" role="radiogroup" aria-labelledby="GroupLabelDateOfBirth">
          <th scope="row" class="text-right" id="GroupLabelDateOfBirth">Date of birth:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="k.checked ? 'selected' : ''">
            <div class="form-check">
              <input #k id="DOB{{i}}" class="form-check-input" type="radio" name="DateOfBirth" value="{{ person?.DateOfBirth }}" (change)="updateDateOfBirth(person.DateOfBirth)" [checked]="personSelected == i" />
              <label for="DOB{{i}}" class="form-check-label">{{ person?.DateOfBirth | date:'MM/dd/yyyy' }}<span *ngIf="!person?.DateOfBirth" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideSSN" role="radiogroup" aria-labelledby="GroupLabelSSN">
          <th scope="row" class="text-right" id="GroupLabelSSN">Social security number:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="l.checked ? 'selected' : ''">
            <div class="form-check">
              <input #l id="SSN{{i}}" class="form-check-input" type="radio" name="SSN" value="{{ person?.SSN }}" (change)="updateSSN(person.SSN)" [checked]="personSelected == i" />
              <label for="SSN{{i}}" class="form-check-label">{{ person?.SSN }}<span *ngIf="!person?.SSN" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideEmailAddress" role="radiogroup" aria-labelledby="GroupLabelSSN">
          <th scope="row" class="text-right" id="GroupLabelSSN">Email addresses:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="n.checked ? 'selected' : ''">
            <div class="form-check">
              <input #n id="Email{{i}}" class="form-check-input" type="radio" name="Email" value="{{ person?.ENESS_XREF_PeopleEmailAccounts[0]?.PeopleEmailAccountsID }}" (change)="updateEmailAddress($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" />
              <label for="Email{{i}}" class="form-check-label">{{ person?.ENESS_XREF_PeopleEmailAccounts[0]?.EmailAccount }}<span *ngIf="!person?.SSN" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hidePersonDescription" role="radiogroup" aria-labelledby="GroupLabelDescription">
          <th scope="row" class="text-right" id="GroupLabelDescription">Description:</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="o.checked ? 'selected' : ''">
            <div class="form-check">
              <input #o id="desc{{i}}" class="form-check-input" type="radio" name="PersonDescription" value="{{ person?.PersonDescription }}" (change)="updatePersonDescription(person.PersonDescription)" [checked]="personSelected == i" />
              <label for="desc{{i}}" class="form-check-label">{{ person?.PersonDescription }}<span *ngIf="!person?.PersonDescription" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideIsKnownFelon" role="radiogroup" aria-labelledby="GroupLabelIsKnownFelon">
          <th scope="row" class="text-right" id="GroupLabelIsKnownFelon">Is known felon?</th>
          <td *ngFor="let person of people; let i = index" [ngClass]="p.checked ? 'selected' : ''">
            <div class="form-check">
              <input #p id="felon{{i}}" class="form-check-input" type="radio" name="IsKnownFelon" value="{{ person?.IsKnownFelon }}" (change)="updateIsKnownFelon(person.IsKnownFelon)" [checked]="personSelected == i" />
              <label for="felon{{i}}" class="form-check-label">{{ person?.IsKnownFelon ? 'Yes' : person?.IsKnownFelon == false ? 'No' : '' }}<span *ngIf="!person?.IsKnownFelon" class="visually-hidden">(No value)</span></label>
            </div>
          </td>
        </tr>
        <tr [hidden]="hideFBI" role="group" aria-labelledby="GroupLabelFBINumbers">
          <th scope="row" class="text-right" id="GroupLabelFBINumbers">FBI file numbers:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleFBIFileNumbers.length > 0; else noFbi" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>File number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of person.ENESS_XREF_PeopleFBIFileNumbers; let idx = index" [ngClass]="q.checked ? 'selected' : ''">
                  <td><input #q id="fbi-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ file.PeopleFBIFileNumbersID }}" (change)="updateFBINumbers($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td><label for="fbi-{{i}}-{{idx}}">{{ file.FBIFileNumber}}</label></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noFbi></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideStateId" role="group" aria-labelledby="GroupLabelStateIDs">
          <th scope="row" class="text-right" id="GroupLabelStateIDs">State ID numbers:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleStateIDNumbers.length > 0; else noState" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>State</th>
                  <th>ID number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let state of person.ENESS_XREF_PeopleStateIDNumbers; let idx = index" [ngClass]="r.checked ? 'selected' : ''">
                  <td><input #r id="stateID-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ state.PeopleStateIDNumbersID }}" (change)="updateStateIds($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td>{{ state?.ENESS_REF_State?.StateName}}</td>
                  <td><label for="stateID-{{i}}-{{idx}}">{{ state.StateIDNumbers}}</label></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noState></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideCityId" role="group" aria-labelledby="GroupLabelCityIDs">
          <th scope="row" class="text-right" id="GroupLabelCityIDs">City ID numbers:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleCityIDNumbers.length > 0; else noCity" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>State</th>
                  <th>City</th>
                  <th>ID number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let city of person.ENESS_XREF_PeopleCityIDNumbers; let idx = index" [ngClass]="s.checked ? 'selected' : ''">
                  <td><input #s id="cityID-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ city.PeopleCityIDNumbersID }}" (change)="updateCityIds($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td>{{ city?.ENESS_REF_Cities?.ENESS_REF_State?.StateName }}</td>
                  <td>{{ city?.ENESS_REF_Cities?.CityName }}</td>
                  <td><label for="cityID-{{i}}-{{idx}}">{{ city.CityIDNumber }}</label></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noCity></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideSocial" role="group" aria-labelledby="GroupLabelSocialMedia">
          <th scope="row" class="text-right" id="GroupLabelSocialMedia">Social media:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleSocialMedia.length > 0; else noSoc" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>Social media</th>
                  <th>Account name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let soc of person.ENESS_XREF_PeopleSocialMedia; let idx = index" [ngClass]="t.checked ? 'selected' : ''">
                  <td><input #t id="social-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ soc.PersonSocialMediaID }}" (change)="updateSocialMedia($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td>{{ soc?.ENESS_REF_SocialMediaTypes?.SocialMediaTypeName }}</td>
                  <td class="break-word"><label for="social-{{i}}-{{idx}}">{{ soc.SocialMediaHandle }}</label></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noSoc></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideDrivers" role="group" aria-labelledby="GroupLabelDriverLicenses">
          <th scope="row" class="text-right" id="GroupLabelDriverLicenses">Driver's licenses:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleDriversLicense.length > 0; else noDL" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>State</th>
                  <th>License number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let dl of person.ENESS_XREF_PeopleDriversLicense; let idx = index" [ngClass]="u.checked ? 'selected' : ''">
                  <td><input #u id="driver-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ dl.PeopleDriversLicenseID }}" (change)="updateDriversLicenses($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td>{{ dl?.ENESS_REF_State?.StateName }}</td>
                  <td><label for="driver-{{i}}-{{idx}}">{{ dl.DriversLicenseNumber }}</label></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noDL></ng-template>
          </td>
        </tr>
        <tr [hidden]="hidePhoneNumber" role="group" aria-labelledby="GroupLabelPhoneNumber">
          <th scope="row" class="text-right" id="GroupLabelPhoneNumber">Phone number(s):</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeoplePhoneNumbers.length > 0; else noPhone" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>Phone number</th>
                  <th>Type</th>
                  <th>Primary</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let phone of person.ENESS_XREF_PeoplePhoneNumbers; let idx = index" [ngClass]="m.checked ? 'selected' : ''">
                  <td><input #m id="phone-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ phone.PeoplePhoneNumbersID }}" (change)="updatePhoneNumber($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td><label for="phone-{{i}}-{{idx}}">{{ phone.PhoneNumber | phoneNumberFormat }}</label></td>
                  <td>{{ phone.ENESS_REF_PhoneNumberTypes?.PhoneNumberType }} <ng-container *ngIf="!!phone.PhoneNumberOtherType">({{ phone.PhoneNumberOtherType }})</ng-container></td>
                  <td><input type="checkbox" value="{{ phone.IsPrimary }}" (change)="updateIsPrimaryPhone(phone.PeoplePhoneNumbersID, i, idx, $event.target['checked'])" [checked]="phone.IsPrimary" /></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noPhone></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideAddress" role="group" aria-labelledby="GroupLabelAddresses">
          <th scope="row" class="text-right" id="GroupLabelAddresses">Addresses:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-active table-bordered" *ngIf="person?.ENESS_XREF_PeopleAddresses.length > 0; else noAddress" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>Street Address</th>
                  <th>Unit</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Postal Code</th>
                  <th>Primary</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let add of person.ENESS_XREF_PeopleAddresses; let idx = index" [ngClass]="w.checked ? 'selected' : ''">
                  <td><input #w id="address-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ add.PeopleAddressesID }}" (change)="updateAddresses($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td><label for="address-{{i}}-{{idx}}">{{ add?.ENESS_Address?.StreetAddress }}</label></td>
                  <td>{{ add?.ENESS_Address?.Unit }}</td>
                  <td>{{ add?.ENESS_Address?.CityName }}</td>
                  <td>{{ add?.ENESS_Address?.ENESS_REF_State?.StateName }}</td>
                  <td>{{ add?.ENESS_Address?.PostalCode }}</td>
                  <td><input type="checkbox" value="{{ add?.IsCurrent }}" (change)="updateIsPrimaryAddress(add.PeopleAddressesID, i, idx, $event.target['checked'])" [checked]="add.IsCurrent" /></td>
                </tr>
              </tbody>
            </table>
            <ng-template #noAddress></ng-template>
          </td>
        </tr>
        <tr [hidden]="hideAttachments" role="group" aria-labelledby="GroupLabelAttachments">
          <th scope="row" class="text-right" id="GroupLabelAttachments">Attachments:</th>
          <td *ngFor="let person of people; let i = index">
            <table class="table-sm table-bordered table-active" *ngIf="person?.ENESS_XREF_PeopleAttachments.length > 0; else noAttach" aria-describedby="DataTable">
              <thead>
                <tr>
                  <th class="table-checkbox"><span class="visually-hidden">Select</span></th>
                  <th>Filename</th>
                  <th>Created By</th>
                  <th>Upload date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of person.ENESS_XREF_PeopleAttachments; let idx = index" [ngClass]="v.checked ? 'selected' : ''">
                  <td><input #v id="attachment-{{i}}-{{idx}}" type="checkbox" class="form-check-input" value="{{ file.PersonAttachmentID }}" (change)="updateAttachments($event.target['value'], $event.target['checked'], i)" [checked]="personSelected == i" /></td>
                  <td><label for="attachment-{{i}}-{{idx}}">{{ file?.ENESS_PersonAttachments?.FileName}}</label></td>
                  <td>{{ file?.ModifiedBy ? file?.ModifiedBy : file?.CreatedBy}}</td>
                  <td>{{ file?.ModifiedOn ? (file?.ModifiedOn | date:'MM/dd/yyyy') : (file?.CreatedOn | date:'MM/dd/yyyy') }}</td>
                </tr>
              </tbody>
            </table>
            <ng-template #noAttach></ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
  <div class="text-center">
    <p-messages [(value)]="mergePeopleValidationMessages"></p-messages>
    <button class="btn btn-sm btn-active my-2" (click)="merge()">Confirm Merge</button>
  </div>
</section>
